var toggleAriaHidden = function (thingy) {
	let attr = thingy.getAttribute('aria-hidden');
	if (attr === 'true') {
		thingy.setAttribute('aria-hidden', false);
	}
	else if (attr === null) {
		thingy.setAttribute('aria-hidden', true);
	}
	else {
		thingy.setAttribute('aria-hidden', true);
	}
};

export default toggleAriaHidden;
